import { RippBadge } from "../v2/primitives";
import { ago } from "./shared";

const sol = (raw) => (raw == null ? "—" : `${(raw / 1e9).toFixed(5)} SOL`);

export const ExecutionLedger = ({ items }) => {
  if (!items?.length) return <div className="h-full grid place-items-center text-[9px] font-mono tracking-[0.18em] text-[var(--r2-text2)]" data-testid="executions-empty">NO ON-CHAIN EXECUTIONS YET</div>;
  return (
    <table className="w-full border-separate border-spacing-0 text-[9.5px] font-mono" data-testid="executions-table">
      <thead className="sticky top-0 r2-glass"><tr>{["When", "Side", "Mint", "Router", "Impact", "Slip", "In → Out", "Latency", "Status"].map((h, i) => <th key={h} className={`px-1.5 py-1 text-[7.5px] tracking-[0.16em] text-[var(--r2-text2)] font-normal uppercase ${i > 3 ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
      <tbody>{items.map((x, i) => {
        const buy = x.side === "BUY";
        const inTxt = buy ? sol(x.in_raw || x.amount_raw) : `${x.in_raw || x.amount_raw} raw`;
        const outTxt = buy ? `${x.out_raw ?? "—"} raw` : sol(x.out_raw);
        return (
          <tr key={x.request_id || i} data-testid={`execution-row-${i}`} className="hover:bg-white/[0.03]">
            <td className="px-1.5 py-1 text-[var(--r2-text2)]">{ago(x.ts)}</td>
            <td className="px-1.5 py-1 font-bold" style={{ color: buy ? "var(--r2-emerald)" : "var(--r2-red)" }}>{x.side}</td>
            <td className="px-1.5 py-1"><a href={`https://solscan.io/token/${x.mint}`} target="_blank" rel="noreferrer" className="hover:text-[var(--meme)]">{x.mint?.slice(0, 4)}…{x.mint?.slice(-4)}</a></td>
            <td className="px-1.5 py-1 text-[var(--r2-text2)]">{x.router || "—"}</td>
            <td className="px-1.5 py-1 text-right tabular-nums" style={{ color: (x.impact_pct || 0) > 2 ? "var(--r2-amber)" : undefined }}>{x.impact_pct != null ? `${x.impact_pct.toFixed(2)}%` : "—"}</td>
            <td className="px-1.5 py-1 text-right tabular-nums">{x.slippage_bps != null ? `${x.slippage_bps}bps` : "—"}</td>
            <td className="px-1.5 py-1 text-right tabular-nums">{inTxt} → {outTxt}</td>
            <td className="px-1.5 py-1 text-right tabular-nums text-[var(--r2-text2)]">{x.latency_ms != null ? `${x.latency_ms}ms` : "—"}</td>
            <td className="px-1.5 py-1 text-right">{x.ok
              ? <a href={x.explorer || `https://solscan.io/tx/${x.signature}`} target="_blank" rel="noreferrer" data-testid={`execution-tx-${i}`}><RippBadge tone="emerald">CONFIRMED ↗</RippBadge></a>
              : <span title={x.error}><RippBadge tone="red">FAILED{x.code != null ? ` ${x.code}` : ""}</RippBadge></span>}</td>
          </tr>
        );
      })}</tbody>
    </table>
  );
};
